import './class-component-hooks'
import Vue from 'vue'
import App from '@/App.vue'
import ElementUI from 'element-ui'
import adminRouter from '@/biz/admin/router'
import businessRouter from '@/biz/business/router'
import 'element-ui/lib/theme-chalk/index.css'
import RouterService from '@/service/RouterService'

import PageContainer from './components/PageContainer.vue'
import DataRender from './components/DataRender.vue'
import ListContainer from './components/ListContainer.vue'
import ButtonSubmit from './components/Button/ButtonSubmit.vue'
import ButtonDelete from './components/Button/ButtonDelete.vue'

import FormRender from './components/Form/FormRender.vue'
import FormInput from './components/Form/FormInput.vue'
import FormText from './components/Form/FormText.vue'
import FormTextarea from './components/Form/FormTextarea.vue'
import FormSelect from './components/Form/FormSelect.vue'
import FormCounter from './components/Form/FormCounter.vue'
import FormRadio from './components/Form/FormRadio.vue'
import FormSwitch from './components/Form/FormSwitch.vue'
import FormDate from './components/Form/FormDate.vue'
import FormCheckbox from './components/Form/FormCheckbox.vue'
import FormCascader from './components/Form/FormCascader.vue'
import FormImage from './components/Form/FormImage.vue'
import FormImages from './components/Form/FormImages.vue'
import FormRangeDate from './components/Form/FormRangeDate.vue'
import FormTime from './components/Form/FormTime.vue'
import FormDateTime from './components/Form/FormDateTime.vue'

import TableRender from './components/Table/TableRender.vue'
import TableText from './components/Table/TableText.vue'
import TableOptions from './components/Table/TableOptions.vue'
import TableCheckbox from './components/Table/TableCheckbox.vue'
import TableImage from './components/Table/TableImage.vue'
import TableImages from './components/Table/TableImages.vue'
import TableCascader from './components/Table/TableCascader.vue'
import TableAction from './components/Table/TableAction.vue'

import CoverImage from './components/Image/CoverImage.vue'

import UserService from '@/service/UserService'
import { getCityName } from './service/ToolsService'

Vue.component('ButtonSubmit', ButtonSubmit)
Vue.component('ButtonDelete', ButtonDelete)
Vue.component('PageContainer', PageContainer)
Vue.component('DataRender', DataRender)
Vue.component('ListContainer', ListContainer)

Vue.component('FormRender', FormRender)
Vue.component('FormInput', FormInput)
Vue.component('FormText', FormText)
Vue.component('FormTextarea', FormTextarea)
Vue.component('FormSelect', FormSelect)
Vue.component('FormCounter', FormCounter)
Vue.component('FormRadio', FormRadio)
Vue.component('FormSwitch', FormSwitch)
Vue.component('FormDate', FormDate)
Vue.component('FormCheckbox', FormCheckbox)
Vue.component('FormCascader', FormCascader)
Vue.component('FormImage', FormImage)
Vue.component('FormImages', FormImages)
Vue.component('FormRangeDate', FormRangeDate)
Vue.component('FormTime', FormTime)
Vue.component('FormDateTime', FormDateTime)

Vue.component('TableRender', TableRender)
Vue.component('TableText', TableText)
Vue.component('TableOptions', TableOptions)
Vue.component('TableCheckbox', TableCheckbox)
Vue.component('TableImage', TableImage)
Vue.component('TableImages', TableImages)
Vue.component('TableCascader', TableCascader)
Vue.component('TableAction', TableAction)

Vue.component('CoverImage', CoverImage)

Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.directive('permission', (el, params) => {
  const result = UserService.hasPermission(params.value)
  if (!result) {
    el.style.display = 'none'
  }
})

Vue.filter('cityName', (value: string) => {
  return getCityName(value, 3, '-')
})

Vue.prototype._env = process.env.VUE_APP_ENV
Vue.prototype._platform = process.env.VUE_APP_PLATFORM
Vue.prototype._isAdminPlatform = process.env.VUE_APP_PLATFORM === 'ADMIN'
Vue.prototype._isBusinessPlatform = process.env.VUE_APP_PLATFORM === 'BUSINESS'

RouterService.init(process.env.VUE_APP_PLATFORM === 'ADMIN' ? adminRouter : businessRouter)

new Vue({
  router: process.env.VUE_APP_PLATFORM === 'ADMIN' ? adminRouter : businessRouter,
  render: h => h(App)
}).$mount('#app')
